import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../../context/AuthContext';

const Layout = () => {
  const { user, logout } = useAuth();
  console.log('user in layout', user);
  // if (!user) {
  //   return <Navigate to="/login" />;
  // }
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar user={user} logout={logout}/>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          bgcolor: 'white',
          pt: 0
        }}
      >
        <Header user={user} logout={logout} />
        <Box sx={{ flexGrow: 1, position: 'absolute', top: '64px', left: 270, right: 0, bottom: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;